import Request from 'gd-request';

class ApiChat {

    constructor() {}

    newOneToOneChatRoom(companyId, userId) {
        return new Request(this, 'POST', 'new-chat', {
            systemType: 1,
            companyId:companyId,
            users: [userId]
        });
    }

    newGroupChatRoom(name, companyId, arrUsers) {
        return new Request(this, 'POST', 'new-chat', {
            systemType: 2,
            name: name,
            companyId: companyId,
            users: arrUsers
        });
    }

    newProjectDiscussionChatRoom(name, companyId, projectId, arrUsers) {
        return new Request(this, 'POST', 'new-chat', {
            systemType: gd.const.chat.systemType.PROJECT_DISCUSSION,
            name: name,
            companyId: companyId,
            projectId: projectId,
            users: arrUsers
        });
    }

    // resetChatRooms() {
    //     return new Request(this, 'GET', 'session/reset-chat-rooms');
    // }

    chatView(chatRoomId) {
        return new Request(this, 'GET', 'chat/'+chatRoomId);
    }

    chatAllMessages(chatRoomId) {
        return new Request(this, 'GET', 'chat/'+chatRoomId+'/all-messages');
    }

    newChatMessage(chatRoomId, message, messageRTF, attachments, tempId) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/new-message', {
            message, messageRTF, attachments, tempId
        });
    }

    editChatMessage(chatRoomId, messageId, message, messageRTF, attachments) {
        return new Request(this, 'PUT', 'chat/'+chatRoomId+'/message/'+messageId, {
            message, messageRTF, attachments
        });
    }

    deleteChatMessage(chatRoomId, messageId) {
        return new Request(this, 'DELETE', 'chat/'+chatRoomId+'/message/'+messageId);
    }

    deleteChatMessageAttachment(chatRoomId, messageId, fileId) {
        return new Request(this, 'DELETE', 'chat/'+chatRoomId+'/message/'+messageId+'/attachment/'+fileId);
    }

    addChatMessageAttachment(chatRoomId, messageId, fileObj) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/message/'+messageId,{
            fileObj
        });
    }

    newUsers(chatRoomId, arrUsers) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/new-users', {
            users: arrUsers
        });
    }

    chatLeave(chatRoomId) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/leave');
    }

    chatDelete(chatRoomId) {
        return new Request(this, 'DELETE', 'chat/'+chatRoomId+'/delete');
    }

    chatRename(chatRoomId, name) {
        return new Request(this, 'PUT', 'chat/'+chatRoomId+'/rename', {
            name: name
        });
    }

    markAsRead(chatRoomId) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/mark-as-read');
    }

    removeUsers(chatRoomId, arrUsers) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/remove-users', {
            users: arrUsers
        });
    }

    star(chatRoomId, messageId) {
        return new Request(this, 'POST', 'chat/'+chatRoomId+'/message/'+messageId+'/star');
    }

    unstar(chatRoomId, messageId) {
        return new Request(this, 'DELETE', 'chat/'+chatRoomId+'/message/'+messageId+'/star');
    }

    //discussion
    updateTodo(chatRoomId, data) {
        return new Request(this, 'PUT', 'chat/{0}/action-items'.f(chatRoomId), {todo:data});
    }
}


module.exports = ApiChat;